export const Experiment = {
  AshbyIntegration: "20230704_ASHBY_ATS_INTEGRATION",
  BooleanSearch: "20240626_HIRE_APP_BOOLEAN_SEARCH",
  NewJobWizard: "20231016_HIRE_APP_NEW_JOB_WIZARD",
  NewStarterJourney: "20241125_NEW_STARTER_JOURNEY",
} as const;
